import React from "react";
import ActionIconButton from "../Shared/ActionIconButton";
import { FaEdit } from "react-icons/fa";

const SettingValue = ({ label, enabled }) => (
  <div className="col-md-6 mb-3">
    <div className="text-muted">{label}</div>
    <span className={`badge ${enabled ? "bg-success" : "bg-secondary"}`}>
      {enabled ? "Enabled" : "Disabled"}
    </span>
  </div>
);

const SiteSettingsView = ({ settings, onEdit }) => (
  <div className="container-fluid p-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <div className="d-flex justify-content-end">
          <ActionIconButton icon={<FaEdit />} label="Edit" variant="edit" onClick={onEdit} />
        </div>
        <div className="row">
          <div className="col-12 mb-4">
            <div className="text-muted mb-2">Site logo</div>
            {settings.siteLogo ? (
              <img
                src={settings.siteLogo}
                alt="Site logo"
                className="img-thumbnail"
                style={{ maxWidth: 240, maxHeight: 140, objectFit: "contain" }}
              />
            ) : (
              <div className="text-muted">No site logo configured</div>
            )}
          </div>
          <SettingValue label="reCAPTCHA" enabled={settings.recaptchaEnable} />
          <SettingValue label="Order verification" enabled={settings.verifyOrderEnable} />
        </div>
      </div>
    </div>
  </div>
);

export default SiteSettingsView;
